import Link from 'next/link';
import emojiFlags from 'emoji-flags';
import { nameFromCC } from 'tf-post-parser';
import AuthorName from '../General/AuthorName';
import FutureImage from '../FutureImage';

// Self-hosted Twemoji SVG (public/flags) — avoids the 79KB flags webfont.
function flagSrc(countryCode) {
  if (!countryCode || !emojiFlags.countryCode(countryCode.toUpperCase()))
    return null;
  return `/flags/${countryCode.toLowerCase()}.svg`;
}

// The community-post card of the expedition-journal system: photo with the
// location flag pinned on it, two-line title, author byline. Extracted from
// RelatedPosts so destination guides, topic collections and the post page
// share one card.
export default function TrailPostCard({ post, sizes, hideFlag }) {
  const flag = hideFlag
    ? null
    : flagSrc(post.location ? post.location.countryCode : undefined);

  return (
    <Link
      href={`/@${post.author.username}/${post.permlink}`}
      prefetch={false}
      className="tw-group tw-block tw-no-underline tw-transition-transform tw-duration-300 hover:-tw-translate-y-1"
    >
      <div className="tw-relative tw-isolate tw-aspect-[16/10] tw-overflow-hidden tw-rounded-xl tw-shadow-[0_14px_30px_-22px_rgba(29,45,40,0.45)] tw-transition-shadow tw-duration-300 group-hover:tw-shadow-[0_26px_48px_-22px_rgba(29,45,40,0.55)]">
        {post.thumb && post.thumb.url ? (
          <FutureImage
            src={post.thumb.url}
            alt=""
            fill
            sizes={
              sizes || '(max-width: 576px) 100vw, (max-width: 992px) 50vw, 33vw'
            }
            maxSrcSetWidth={1200}
            placeholder={post.thumb.blur ? 'blur' : undefined}
            blurDataURL={post.thumb.blur}
            className="tw-object-cover tw-transition-transform tw-duration-500 group-hover:tw-scale-[1.04]"
          />
        ) : (
          <div className="tw-absolute tw-inset-0 tw-rounded-xl tw-border tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-bg-[#F6F3E9] dark:tw-bg-[#16241F]" />
        )}
        {/* Location flag lives on the photo — never next to the author's
            name, where it would read as nationality. */}
        {flag && (
          <span
            title={
              post.location && post.location.countryCode
                ? nameFromCC(post.location.countryCode)
                : undefined
            }
            className="tw-absolute tw-left-2 tw-top-2 tw-flex tw-items-center tw-rounded-full tw-bg-white/85 tw-px-1.5 tw-py-0.5 tw-shadow-sm tw-backdrop-blur-sm"
          >
            <img
              src={flag}
              alt=""
              aria-hidden="true"
              width={13}
              height={13}
              loading="lazy"
              className="tw-h-[13px] tw-w-[13px]"
            />
          </span>
        )}
      </div>
      <p className="tw-mb-0 tw-mt-3 tw-overflow-hidden tw-text-[17px] tw-font-semibold tw-leading-snug tw-text-gray-900 dark:tw-text-gray-100 group-hover:tw-text-primary-700 dark:group-hover:tw-text-primary-300 [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [display:-webkit-box]">
        {post.title}
      </p>
      <p className="tw-mb-0 tw-mt-1.5 tw-text-[13px] tw-text-gray-500 dark:tw-text-gray-400">
        <AuthorName author={post.author} />
      </p>
    </Link>
  );
}
